module.exports = __webpack_public_path__ + "static/media/SignaPay-White.762b877a.png";